module.exports = __webpack_public_path__ + "static/media/VattenfallHall-Light.3de80839.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VattenfallHallLight/VattenfallHall-Light.woff
// module id = 195
// module chunks = 0